import React from 'react';
import { Text } from '@rsos/components/capstone/base';
import { notifyError } from '@rsos/utils/toastUtils';

const layerErrorMessage = (
  <Text>
    Error loading your local GIS data. Contact{' '}
    <a href="mailto:support@rapidsos.com">support@rapidsos.com</a> if this error
    persists.
  </Text>
);

export const notifyEsriMapLayerError = () =>
  notifyError({ message: layerErrorMessage });
